// 🔌 윈도우 부팅 시 자동 시작 (2026-08-07 사용자 요청 — 기본 ON).
// tauri-plugin-autostart(Rust) 의 커맨드를 core invoke 로 직접 호출한다.
//   @tauri-apps/plugin-autostart npm 패키지를 추가하지 않는 이유: 커맨드가 3개뿐이라
//   `plugin:autostart|<cmd>` 규약으로 충분하고, 모노레포 의존성을 늘리지 않기 위해.
// 웹/모바일에서는 전부 no-op (isTauri()=false) — 호출측에서 분기하지 않아도 안전.

import { isTauri } from './env';

// "한 번이라도 기본값을 적용했는가" — 사용자가 끈 뒤 재시작 때 다시 켜지는 것을 막는 플래그.
const INIT_KEY = 'tpt-autostart-initialized';

async function call<T>(cmd: 'enable' | 'disable' | 'is_enabled'): Promise<T | null> {
	if (!isTauri()) return null;
	try {
		const { invoke } = await import('@tauri-apps/api/core');
		return await invoke<T>(`plugin:autostart|${cmd}`);
	} catch (e) {
		console.warn(`[desktop] autostart ${cmd} 실패:`, (e as Error).message);
		return null;
	}
}

/** 현재 등록 여부. 데스크톱이 아니거나 조회 실패면 null. */
export async function isAutostartEnabled(): Promise<boolean | null> {
	const v = await call<boolean>('is_enabled');
	return typeof v === 'boolean' ? v : null;
}

/** 등록/해제. 성공 여부를 반환(데스크톱 아님·실패 = false). */
export async function setAutostart(on: boolean): Promise<boolean> {
	const r = await call<unknown>(on ? 'enable' : 'disable');
	if (r === null) return false;
	try { localStorage.setItem(INIT_KEY, '1'); } catch { /* private mode */ }
	return true;
}

/**
 * 최초 1회 기본값(ON) 적용 — 앱 부팅 시 호출.
 * 이미 적용한 적이 있으면(사용자가 껐을 수도 있으므로) 아무것도 하지 않는다.
 */
export async function ensureAutostartDefault(): Promise<void> {
	if (!isTauri()) return;
	let done = false;
	try { done = localStorage.getItem(INIT_KEY) === '1'; } catch { /* private mode */ }
	if (done) return;
	const cur = await isAutostartEnabled();
	if (cur === null) return;             // 플러그인 미탑재(구버전 앱) — 플래그도 남기지 않음
	if (!cur) await call('enable');
	try { localStorage.setItem(INIT_KEY, '1'); } catch { /* private mode */ }
}
